import { Brand } from '../types';
import { uint8ArrayEqual, loadArrayOrBase64, ArrayOrBase64 } from '../utils';

export type Hash = Brand<Uint8Array<ArrayBuffer>, 'Hash'>;

// We use SHA512 truncated to 256 bits instead of just SHA256, because our
// crypto was originally fully based on libsodium, which only exposes SHA512.
// We don't need a full 512 bits, so WebCrypto's SHA-512 output is truncated to
// 32 bytes / 256 bits. This is similar to SHA512/256 (with a different IV).
// See p27 of https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
const HASH_LENGTH = 32;

export function loadHash(data: ArrayOrBase64): Hash {
  return loadArrayOrBase64(data, HASH_LENGTH) as Hash;
}

export async function hashData(blob: Uint8Array<ArrayBuffer>): Promise<Hash> {
  const digest = await crypto.subtle.digest('SHA-512', blob);
  return loadHash(new Uint8Array(digest, 0, HASH_LENGTH));
}

export function hashEqual(hash1: Hash, hash2: Hash) {
  return uint8ArrayEqual(hash1, hash2);
}

export async function verifyHash(hash: Hash, blob: Uint8Array<ArrayBuffer>): Promise<boolean> {
  return hashEqual(hash, await hashData(blob));
}
